import {InjectionToken} from '@angular/core';
import {LearningPackageInsightsDetailsResponseDto} from './rest/api-types/LearningPackageInsightsDetailsResponseDto';
import {Observable} from 'rxjs';
import {
    LearningPackageInsightsQuestionsResponseDto
} from './rest/api-types/LearningPackageInsightsQuestionsResponseDto';
import {TimePeriodMode} from './rest/api-types/TimePeriodMode';
import {LearningProgressHistoryResponseDto} from './rest/api-types/LearningProgressHistoryResponseDto';
import {
    LearningPackageInsightsSkillsProfileResponseDto
} from './rest/api-types/LearningPackageInsightsSkillsProfileResponseDto';
import {LearningPackageInsightsTopicsResponseDto} from './rest/api-types/LearningPackageInsightsTopicsResponseDto';

export const LEARNING_PROGRESS_INSIGHT = new InjectionToken<LearningProgressInsightService>('LEARNING_PROGRESS_INSIGHT');

export interface LearningProgressInsightService {
    getLearningProgressInsightDetails(learningPackageId: string): Observable<LearningPackageInsightsDetailsResponseDto>;

    getLearningProgressInsightQuestionsOverview(learningPackageId: string): Observable<LearningPackageInsightsQuestionsResponseDto>;

    learnLearningPackage(learningPackageId: string): Promise<void> | void;

    getLearningProgressInsightHistory(learningPackageId: string, timePeriodMode: TimePeriodMode): Observable<LearningProgressHistoryResponseDto>;

    getSkillsProfileInsightHistory(learningPackageId: string): Observable<LearningPackageInsightsSkillsProfileResponseDto>;

    getLearningProgressInsightTopicsOverview(learningPackageId: string): Observable<LearningPackageInsightsTopicsResponseDto>;
}
